var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100 p-3 text-center d-flex flex-column text-uppercase",attrs:{"id":"app"}},[_c('top-bar',{staticClass:"mb-3"}),_c('router-view',{staticClass:"flex-grow-1"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }